var exports = {
  "UU": "x127c5a35--45f11d--name",
  "lZ": "x127c5a35--45f11d--phone",
  "N4": "x127c5a35--45f11d--note",
};

module.exports = exports;
